import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar/Navbar';
import Footer from './Footer/Footer';

const LandingPage = () => {
    return (
        <div className="flex flex-col min-h-screen relative bg-white scroll-enabled">
            <Navbar />
            <main id="main-content" role="main" tabIndex="-1" className="flex-grow outline-none">
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default LandingPage;
